import { uuid, toArray } from './util';
var Pseudo;

(function (Pseudo) {
  function clonePseudoElement(nativeNode, clonedNode, pseudo) {
    var style = window.getComputedStyle(nativeNode, pseudo);
    var content = style.getPropertyValue('content');

    if (content === '' || content === 'none') {
      return;
    }

    var className = uuid(); // fix: Cannot assign to read only property 'className' of object '#<…

    try {
      clonedNode.className = "".concat(clonedNode.className, " ").concat(className);
    } catch (err) {
      return;
    }

    var styleElement = document.createElement('style');
    styleElement.appendChild(getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
  }

  Pseudo.clonePseudoElement = clonePseudoElement;

  function getPseudoElementStyle(className, pseudo, style) {
    var selector = ".".concat(className, ":").concat(pseudo);
    var cssText = style.cssText ? formatCssText(style) : formatCssProperties(style);
    return document.createTextNode("".concat(selector, "{").concat(cssText, "}"));
  }

  function formatCssText(style) {
    var content = style.getPropertyValue('content');
    return "".concat(style.cssText, " content: '").concat(content.replace(/'|"/g, ''), "';");
  }

  function formatCssProperties(style) {
    return toArray(style).map(function (name) {
      var value = style.getPropertyValue(name);
      var priority = style.getPropertyPriority(name);
      return "".concat(name, ": ").concat(value).concat(priority ? ' !important' : '', ";");
    }).join(' ');
  }
})(Pseudo || (Pseudo = {}));

export function clonePseudoElements(nativeNode, clonedNode) {
  var pseudos = [':before', ':after'];
  pseudos.forEach(function (pseudo) {
    return Pseudo.clonePseudoElement(nativeNode, clonedNode, pseudo);
  });
}